const React = require("react");
const Link = require("../../core/view/Link");
const URLMake = require("../../../shared/URLMake");

const styles = require("../styles/PageChalkboard.css");

const ChalkboardData = {
	learnMore: (
		<Link className={styles.learnLink} to={URLMake.forBookstore()}>
			{"Want to learn more? "}
			<br className={styles.learnBreak} />
			{"Click here to become a Math Beast today!"}
		</Link>
	),
	current: [
		{
			question: "What is the sum of every integer from -50 to 50?",
			answer: (
				<div>
					<p>
						{`To add (-50)+(-49)+(-48)+...+48+49+50, we can pair all of the terms that sum to 0.
          For example, we can pair (-50)+50=0, and (-49)+49=0, all the way to (-1)+1=0.
          The only integer left without a partner is 0.`}
					</p>
					<p>
						{`So, (-50)+(-49)+(-48)+...+48+49+50 is equal to (-50+50)+(-49+49)+(-48+48)+...+(-2+2)+(-1+1)+0,
          which is the sum of a bunch of zeros! No matter how many zeros you add, the sum is still 0.`}
					</p>
					<p>
						{`So, the sum of all the integers from -50 to 50 is `}
						<span className={styles.boxed}>{"0"}</span>
						{"."}
					</p>
					<p>
						{`To learn more about adding integers, try the Integers chapter of `}
						<Link className={styles.link} to={URLMake.forBook("4C")}>
							{"Beast Academy 4C"}
						</Link>
						{"."}
					</p>
				</div>
			),
		},
		{
			question: "What is the remainder when 77 times 88 is divided by 9?",
			answer: (
				<div>
					<p>
						{`Suppose you had 77 boxes of 88 marbles, and you wanted to divide them equally among 9 friends.
          You could start by giving 8 whole boxes of marbles to each friend. That takes care of 8×9=72 of the boxes,
          but you still have 77–72=5 boxes left over.`}
					</p>
					<p>
						{`With each remaining box of 88 marbles, you can give 9 marbles to each friend. That takes care of 9×9=81
          marbles from each box, but you still have 88–81=7 marbles left in each box.`}
					</p>
					<p>
						{`Now, you are down to 5 boxes, each with 7 marbles. That's 5×7=35 marbles. You can give each of the 9
          friends 3 marbles. That takes care of 3×9=27 marbles, and you have 35–27=8 marbles left.
          That's the remainder!`}
					</p>
					<p>
						{`In other words, to find the remainder when 77 times 88 is divided by 9, we can find the remainder of
          77÷9 and the remainder of 88÷9, multiply those remainders, then divide by 9. The remainder when (77×88)
          is divided by 9 is the same as the remainder when (5×7) is divided by 9.`}
					</p>
					<p>
						{`5×7=35, and 35÷9 has remainder `}
						<span className={styles.boxed}>{"8"}</span>
						{"."}
					</p>
					<p>
						{`To learn more about finding remainders, try the Division chapter of `}
						<Link className={styles.link} to={URLMake.forBook("3C")}>
							{"Beast Academy 3C"}
						</Link>
						{"."}
					</p>
				</div>
			),
		},
		{
			question: (
				<span>
					What is the units digit of 3<sup>33</sup>?
				</span>
			),
			answer: (
				<div>
					<p>
						{`Let's start with some smaller powers of 3 and look for a pattern.`}
					</p>
					<p>
						<span>
							3<sup>1</sup>
							=3, which has units digit 3.
						</span>
						<br />
						<span>
							3<sup>2</sup>
							=3×3=9, which has units digit 9.
						</span>
						<br />
						<span>
							3<sup>3</sup>
							=3×3×3=27, which has units digit 7.
						</span>
						<br />
						<span>
							3<sup>4</sup>
							=3×3×3×3=81, which has units digit 1.
						</span>
						<br />
						<span>
							3<sup>5</sup>
							=3×3×3×3×3=243, which has units digit 3.
						</span>
						<br />
						<span>
							3<sup>6</sup>
							=3×3×3×3×3×3=729, which has units digit 9.
						</span>
						<br />
					</p>
					<p>
						<span>
							{`These numbers are getting big! Luckily, we only care about the units digits of these powers of 3.
          Multiplying 3`}
							<sup>6</sup>
							{"=729 by another 3 gives us 3"}
							<sup>7</sup>
							{`. Multiplying any number that has
          units digit 9 by 3 gives a result with units digit 7.`}
						</span>
					</p>
					<p>
						<span>
							So, 3<sup>7</sup> has units digit 7.
						</span>
					</p>
					<p>
						<span>
							Multiplying 3<sup>7</sup> by another 3 gives us 3<sup>8</sup>
							{`. Multiplying any number that has units
          digit 7 by 3 gives a result with units digit 1.`}
						</span>
					</p>
					<p>
						<span>
							So, 3<sup>8</sup> has units digit 1.
						</span>
					</p>
					<p>
						{`We can keep going this way to see that the units digits of the powers of 3 repeat in the pattern
          3, 9, 7, 1, 3, 9, 7, 1, 3, 9, 7, 1,... and on and on like that forever.`}
					</p>
					<p>
						<span>
							So, 3<sup>1</sup>, 3<sup>5</sup>, 3<sup>9</sup>, 3<sup>13</sup>, 3
							<sup>17</sup>, 3<sup>21</sup>, 3<sup>25</sup>, 3<sup>29</sup>, and
							3<sup>33</sup>
							{" all have the same units digit, which is "}
							<span className={styles.boxed}>{"3"}</span>.
						</span>
					</p>
					<p>
						{`To learn more about exponents and units digits, try the Exponents chapter of `}
						<Link className={styles.link} to={URLMake.forBook("4A")}>
							{"Beast Academy 4A"}
						</Link>
						{"."}
					</p>
				</div>
			),
		},
	],
	previous: [],
};

module.exports = ChalkboardData;
